// src/components/alert/ContractStatus.tsx

import { Alert, AlertProps } from '@mui/material'

import { FolderContractView, FolderId } from '@/types/domain/folder'

import { DMMMMYYYY, userLocales } from '../../api'
import { useFolderContract } from '../../hooks'

type ContractStatusProps = {
  id: FolderId
  locales?: string | string[]
  options?: Intl.DateTimeFormatOptions
}

export const ContractStatus = ({
  id,
  locales = userLocales,
  options = DMMMMYYYY,
}: ContractStatusProps) => {
  const contract: FolderContractView = useFolderContract(id)

  if (!contract) return null
  const {
    date_begin: begin,
    date_expire: expire,
    severity,
  } = contract as {
    date_begin: string
    date_expire: string
    severity?: AlertProps['severity']
  }

  const fmtDate = (date: string | number | Date) =>
    new Date(date).toLocaleDateString(locales, options)
  const isValid = (date: Date) => !isNaN(date.getTime())

  const BEGIN = new Date(begin)
  const EXPIRE = new Date(expire)
  const NOW = new Date()

  const status =
    !isValid(BEGIN) || !isValid(EXPIRE) || BEGIN > EXPIRE
      ? 'ungültig'
      : NOW.getTime() > EXPIRE.getTime()
        ? 'abgelaufen'
        : NOW.getTime() < BEGIN.getTime()
          ? 'geplant'
          : NOW.getTime() > BEGIN.getTime() && NOW.getTime() < EXPIRE.getTime()
            ? 'aktiv'
            : `unvorhergesehen! id:${id} | ${fmtDate(begin)} - ${fmtDate(expire)}`

  const runtime = `${fmtDate(begin)} - ${fmtDate(expire)}`

  return (
    <Alert severity={severity}>
      Vertragslizenz: <strong>{status}</strong> {runtime}
    </Alert>
  )
}
